// Theme configuration for the manufacturing guide
// This can be easily modified to change the branding colors

export const themeConfig = {
  colors: {
    primary: "#00476B", // Deep navy blue as requested
    secondary: "#f8fafc", // Light background color
    accent: "#e2e8f0", // Light accent color
    text: {
      primary: "#1e293b", // Dark text
      secondary: "#64748b", // Medium gray text
      light: "#ffffff", // White text
    },
    background: {
      light: "#ffffff", // White background
      dark: "#f1f5f9", // Light gray background
    },
    status: {
      success: "#10b981", // Green
      error: "#ef4444", // Red
      warning: "#f59e0b", // Amber
      info: "#3b82f6", // Blue
    },
  },
  // Add other theme properties as needed
  borderRadius: {
    sm: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
  },
  spacing: {
    // Add custom spacing if needed
  },
}

// Helper function to get color values
export function getColor(path: string): string {
  const keys = path.split(".")
  let value: any = themeConfig

  for (const key of keys) {
    if (value[key] === undefined) {
      console.warn(`Theme color path "${path}" not found`)
      return "#000000" // Default fallback
    }
    value = value[key]
  }

  return value
}
